import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IProductMasterStatusesResponse } from "../models/product/dto/product-master-status-response";
import { ProductOptions } from "../models/product/product-option.model";
import { IProductTypes } from "../models/product/product.model";
import { EnvironmentService } from "./environment.service";

@Injectable({
    providedIn: 'root'
  })
export class ProductOptionService {
    fullPath: any;
    constructor(private httpClient: HttpClient,
        public envService: EnvironmentService) {
            this.fullPath = `${this.envService.settings.apiUrl}/options`;
    }
    public getOptions(): Observable<ProductOptions> {
        return this.httpClient.get<ProductOptions>(`${this.envService.settings.apiUrl}/options`);
    }

    public getProductType(): Observable<IProductTypes> {
        return this.httpClient.get<IProductTypes>(`${this.envService.settings.apiUrl}/productTypes`);
    }

    public getProductMasterStatuse(productId?: string): Observable<IProductMasterStatusesResponse> {
        return productId ? this.httpClient.get<IProductMasterStatusesResponse>(`${this.fullPath}/masterstatuses?productId=${productId}`)
        : this.httpClient.get<IProductMasterStatusesResponse>(`${this.fullPath}/masterstatuses`);
     }
}